import { render, staticRenderFns } from "./KczxNav.vue?vue&type=template&id=ecef9c4a&scoped=true&"
import script from "./KczxNav.vue?vue&type=script&lang=js&"
export * from "./KczxNav.vue?vue&type=script&lang=js&"
import style0 from "./KczxNav.vue?vue&type=style&index=0&id=ecef9c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecef9c4a",
  null
  
)

export default component.exports